import React from 'react';

import VisCompilatie from './VisCompilatie';
import VisWat from './VisWat';
import VisWaarom from './VisWaarom';
import VisHoe from './VisHoe';
import VisPresentatievormen from './VisPresentatievormen';
import VisUitleg from './VisUitleg';
import VisBoxPlots from './VisBoxPlots';
import VisPuntenWolk from './VisPuntenWolk';

// import VisVoorbeeldHuishoudens from './VisVoorbeeldHuishoudens';
// import VisKolomGrafiek from './VisKolomGrafiek';
// import VisMedianenTabel from './VisMedianenTabel';


import StyledVisualization from './StyledVisualization';

const Visualization = (props) => {

	const { currentStep, slideHeight  } = props;

	const showVis = {
		1: <VisCompilatie />,
		2: <VisWat {...props }  />,
		3: <VisWat {...props }  />,
		4: <VisWat {...props }  />,
		5: <VisWaarom {...props} />,
		6: <VisWaarom {...props} />,
		7: <VisHoe {...props} />,
		8: <VisHoe {...props} />,
		9: <VisHoe {...props} />,
		10: <VisPresentatievormen {...props} />,
		11: <VisUitleg {...props} />,
		12: <VisUitleg {...props} />,
		13: <VisBoxPlots {...props} />,
		14: <VisPuntenWolk {...props} />,
		15: <VisPuntenWolk {...props} />,
		16: <VisPuntenWolk {...props} />
	}

	return (
		<StyledVisualization slideHeight={slideHeight} >
			{showVis[currentStep]}
		</StyledVisualization>
		)
}

export default 	Visualization;



// WEBPACK FOOTER //
// ./src/components/Visualization/Visualization.js